import React from "react";
import { FileDownloadOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";

import ChipList, { IChipListItem } from "./chipList";
import Loading from "./loading";

interface IChipListWithButtonProps {
    downloadText: string;
    isFetching: boolean;
    items: IChipListItem<string, string>[];

    onClick: (args: any) => void;
    onChipClose: (args: any) => void;
}

const ChipListWithButton: React.FC<IChipListWithButtonProps> = ({
    downloadText,
    isFetching,
    items,
    onClick,
    onChipClose
}) => {
    return (
        <div>
            <ChipList
                closable
                onClose={onChipClose}
                items={items}
                truncateAtIndex={4}
                emptyChipDetails={{show: false, contents: "No users"}}
            />
                <Button 
                    style={{marginLeft: "auto", border: "none", boxShadow: "none"}} 
                    disabled={false}
                    onClick={onClick}
                    variant="text"
                    startIcon={<FileDownloadOutlined />}
                    endIcon={isFetching ? <Loading size={12} padding={0}/> : null}
                >
                    {downloadText}
            </Button>
        </div>
    );
}

export default ChipListWithButton;